<script setup lang="ts">
import Box from '@uiKit/elements/Box.vue'
import type { BoxSpace } from '@uiKit/elements/Box.vue'

export type CardVariant = 'elevated' | 'outlined' | 'flat'

interface Props {
  /** Semantic HTML tag. Default `'div'`. Use `is="article"` / `"section"` for content cards. */
  is?: string
  /**
   * Card chrome.
   * - `elevated` (default) — white bg, small shadow, no border
   * - `outlined` — white bg, 1px border, no shadow
   * - `flat` — white bg, no border, no shadow
   */
  variant?: CardVariant
  /** Internal padding. Default `'4'` (1rem). Token or raw CSS length. */
  padding?: BoxSpace | (string & {})
}

withDefaults(defineProps<Props>(), {
  is: 'div',
  variant: 'elevated',
  padding: '4',
})

defineOptions({ inheritAttrs: false })
</script>

<template>
  <Box v-bind="$attrs" :is="is" :padding="padding" :class="['card', `card--${variant}`]">
    <slot />
  </Box>
</template>

<style scoped>
.card {
  background: var(--p-surface-0);
  border-radius: 12px;
  box-sizing: border-box;
}

.card--elevated {
  box-shadow:
    0 24px 48px -16px rgba(15, 23, 42, 0.08),
    0 8px 16px -8px rgba(15, 23, 42, 0.05),
    0 1px 2px rgba(15, 23, 42, 0.04);
}

.card--outlined {
  border: 1px solid var(--p-content-border-color);
}

.card--flat {
  /* no border, no shadow — just bg + radius */
}
</style>
